import { Link } from "react-router-dom";

export interface Crumb {
  label: string;
  to?: string;
}

export default function Breadcrumb({ crumbs }: { crumbs: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航" className="flex flex-wrap items-center gap-1.5 text-xs md:text-sm text-foreground-500">
      {crumbs.map((c, i) => (
        <span key={`${c.label}-${i}`} className="flex items-center gap-1.5">
          {i > 0 && <i className="ri-arrow-right-s-line text-foreground-300"></i>}
          {c.to ? (
            <Link to={c.to} className="hover:text-primary-600 transition-colors">
              {c.label}
            </Link>
          ) : (
            <span className="text-foreground-800 font-medium">{c.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}